const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://z0sepej86c.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://72g1dj2hu5.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://q7fuljjvb7.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.staging.barrick.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.barrick.forwoodsafety.com',
    WEBSOCKET: 'wss://mdwceyl46c.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;